import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useState } from 'react';

import ConfirmButton from 'primitives/ConfirmButton';

const ADMIN_CREATE_PORTFOLIO_UPDATE_REQUEST_MUTATION = gql(`
  mutation AdminCreatePortfolioUpdateRequest($dealId: ID!) {
    adminCreatePortfolioUpdateRequest(dealId: $dealId) {
      id
      status
      createdAt
    }
  }
`);

const RequestPortfolioUpdateButton: FC<{ dealId: string }> = ({ dealId }) => {
  const [success, setSuccess] = useState(false);

  const [adminCreatePortfolioUpdateRequest, { loading, error }] = useMutation(
    ADMIN_CREATE_PORTFOLIO_UPDATE_REQUEST_MUTATION,
    {
      onCompleted() {
        setSuccess(true);
      },
    }
  );

  return (
    <div className="bg-white border border-gray-200 sm:rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-base font-semibold leading-6 text-gray-900">
          Request Portfolio Update
        </h3>
        <div className="mt-1 sm:flex sm:items-start sm:justify-between">
          <div className="max-w-xl text-base text-gray-500">
            {success ? (
              <p className="text-green-600">
                Request sent — the syndicate lead has been notified by email.
              </p>
            ) : (
              <p>
                Send an email to the syndicate lead requesting them to publish a portfolio update
                for this deal.
              </p>
            )}
          </div>
          {!success && (
            <div className="mt-5 sm:ml-6 sm:mt-0 sm:flex sm:flex-shrink-0 sm:items-center">
              <ConfirmButton
                variant="secondary"
                onConfirm={() => adminCreatePortfolioUpdateRequest({ variables: { dealId } })}
                loading={loading}
                error={error}
                description="This will email all syndicate leads asking them to publish a portfolio update."
              >
                Request Update
              </ConfirmButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestPortfolioUpdateButton;
